import React from "react";
import Image from "components/image";
import OkendoStarRating from "components/okendo/star-rating";
import Money from "components/money";
import { trackSelectItem } from "analytics";
import { useCustomer } from "hooks/useStore";
import Link from "components/link";
import getProductUrl from "utils/product-url";

const ExpandedProductItem = ({ product, index }) => {
	const customer = useCustomer();

	const { handle, title, variants, variant, previewImages } = product || {};

	const handleProductClick = (event) => {
		event.stopPropagation();
		trackSelectItem({ ...product, index }, customer);
	};

	return (
		<Link
			to={getProductUrl({ handle, variant, variants })}
			onClick={handleProductClick}
			onKeyDown={(e) => e.key === "Enter" && handleProductClick(e)}
			tabIndex={0}
			aria-label={`View ${title}`}
			className="group/card flex animate-blurIn flex-col gap-2.5">
			<div className="w-full relative overflow-hidden">
				<Image className="img-transition-scale" image={previewImages[0]} />
			</div>
			<div className="md:px-4 md:pt-1.5 md:pb-4 flex flex-col gap-3 md:gap-4 md:shadow-sm">
				<div className="w-full">
					<div className="flex justify-between flex-col sm:flex-row gap-1.5 md:gap-3">
						<div className="flex flex-col items-start gap-1">
							<h5 className="text-sm font-bold md:font-bold md:text-lg font-base">{product.title}</h5>
							<OkendoStarRating reviewAggregate={product?.reviewAggregate} productId={product.id} />
						</div>
						<div className="product-item-price md:flex-col items-start md:items-end flex-1">
							<span className="text-secondary text-xs md:text-sm pr-2">From</span>
							<p className="text-sm md:text-lg md:ml-2 font-semibold text-start md:text-end md:max-w-fit">
								<Money value={product.minVariantPrice} markets={product.variant?.markets} />
							</p>
						</div>
					</div>
				</div>
				<button className="btn-secondary w-full text-xs py-2 lg:py-3">
					View
				</button>
			</div>
		</Link>
	);
};


export default ExpandedProductItem;